module.exports = __webpack_public_path__ + "img/icon-contact.19615b44.svg";